import type { VtexLog, VtexLogLevel } from '../VtexLog'
import type { PinoLog } from '../pino/PinoLog'
import { toExtraFields } from './toExtraFields'
import { formatRFC3339 } from '../../utils/time/formatRFC3339'
import { isErrorLike } from '../../utils/type/isErrorLike'

const PINO_LOG_VALUE_TO_VTEX_LOG_LEVEL: Record<number, VtexLogLevel> = {
  10: 'debug',
  20: 'debug',
  30: 'info',
  40: 'warning',
  50: 'error',
  60: 'fatal',
}

// TODO: implement automated tests for it
export const toVtexLog = (log: PinoLog): VtexLog => {
  const {
    level,
    searchIndex,
    account,
    workflowType,
    workflowInstance,
    msg,
    err,
    error = err,
    time,
    ...extraFields
  } = log

  const hasError = isErrorLike(error)

  return {
    type: 'log',
    level: PINO_LOG_VALUE_TO_VTEX_LOG_LEVEL[level] ?? 'debug',
    vtex: {
      search_index: String(searchIndex),
      account: String(account ?? '-'),
      workflow_type: String(workflowType ?? '-'),
      workflow_instance: String(workflowInstance ?? '-'),
      ...(hasError
        ? {
            exception: { type: error.type, message: error.message },
            stack_trace: { data: error.stack },
          }
        : {}),
    },
    timestamp: formatRFC3339(new Date(time)),
    message: msg ?? '-',
    extra_fields: toExtraFields(extraFields),
  }
}
